




import Vue from "vue";

import { GetMFAStatusCommand } from "@/model/communication/users/MFA/GetMFAStatusCommand";
import { EnableMFACommand } from "@/model/communication/users/MFA/EnableMFACommand";
import { DisableMFACommand } from "@/model/communication/users/MFA/DisableMFACommand";
import { DownloadMFAInstructions } from "@/model/communication/users/MFA/DownloadMFAInstructions";

export default Vue.extend({
    data() {
        return {
            loading: false,
            mfaEnabled: false,
            disabled: false,
            downloadLoading: false,
        };
    },
    props: {
        username: String,
    },
    watch: {
        username: {
            handler() {
                this.fetchMFAStatus();
            },
            immediate: true,
        },
    },
    methods: {
        async downloadInstructions() {
            this.downloadLoading = true;
            const res = await new DownloadMFAInstructions(this.username).execute();

            let fileURL = window.URL.createObjectURL(new Blob([res.data]));
            let fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", res.headers["content-disposition"].substring("attachment; filename=".length));
            document.body.appendChild(fileLink);
            fileLink.click();
            this.downloadLoading = false;
        },
        async onSwitchChange(val: boolean) {
            this.loading = true;
            if (val) {
                await new EnableMFACommand(this.username).execute();
                this.downloadInstructions();
            } else await new DisableMFACommand(this.username).execute();
            this.fetchMFAStatus();
            this.loading = false;
        },
        async fetchMFAStatus() {
            this.loading = true;
            const res = await new GetMFAStatusCommand(this.username).execute();
            this.mfaEnabled = res.isEnabled;
            this.loading = false;
        },
    },
});
